import http from "@/utils/request";

const taxAccountStatementApi = {
  pageQuery: (data) =>
    http.sendRequest({
      METHOD_NAME: "taxAccountStatement.pageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  submitTaxExpenseBuildExcelTask: (data) =>
    http.sendRequest({
      METHOD_NAME: "taxAccountStatement.submitTaxExpenseBuildExcelTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  expenseTaxReturn: (data) =>
    http.sendRequest({
      METHOD_NAME: "taxAccountStatement.expenseTaxReturn",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

export default taxAccountStatementApi;
